document.addEventListener("DOMContentLoaded", () => {
	const featureItems = document.querySelectorAll(".wp-block-td-blocks-plugin-feature-left-col");
	featureItems.forEach((item) => {
		item.addEventListener("click", () => {
			setTimeout(() => {
				if(window.innerWidth >= 768) return; // only for mobile
				item.scrollIntoView({block: "start", behavior: "smooth"});
			}, 300);
		});
	});
});
